import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface SiteOption {
  id: string;
  name: string;
}

@Component({
  selector: 'app-site-selector',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './site-selector.component.html',
  styleUrls: ['./site-selector.component.scss']
})
export class SiteSelectorComponent {
  /** List of sites available for the user */
  @Input() sites: SiteOption[] = [];

  /** Currently selected site ID */
  @Input() selectedSite: string = '';

  /** Emits when user changes selection */
  @Output() siteChanged = new EventEmitter<string>();

  onChange() {
    this.siteChanged.emit(this.selectedSite);
  }
}
